import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { HUBSPOT_CREDITS_CARD } from '../../../constants/tracking/TrackingSources';
import { usePurchaseMotionsForHubSpotCreditsTile } from '../../../features/purchaseMotions/hooks/usePurchaseMotionsForHubSpotCreditsTile';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useCurrentNavItem } from '../../../hooks/useCurrentNavItem';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { productSelector } from '../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { MerchCardLayoutUI } from '../../../v2/components/MerchCardLayoutUI';
import { CreditsFeatures } from '../features-display/CreditsFeaturesInbound25';
import HubSpotCreditsTileCTAs from './HubSpotCreditsTileCTAs';
import HubSpotCreditsTilePrice from './HubSpotCreditsTilePrice';
import { SIZE_TO_QUANTITY_MAP } from './constants';
import { configureHubSpotCreditsProductConfigurations } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsTileInbound25 = ({
  subscreen,
  size,
  location,
  unlockHubSpotCreditsSkuIds,
  columnStart,
  isCollapsible = false
}) => {
  const screen = useCurrentNavItem();
  const isAppReady = useGlobalLoading();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const creditsProduct = useAppSelector(state => {
    if (!isAppReady) {
      return null;
    }
    return productSelector(state, {
      apiName: 'hubspot-credits-committed'
    });
  });
  const creditsSkuId = creditsProduct === null || creditsProduct === void 0 ? void 0 : creditsProduct.currentSkuId;
  const {
    purchaseProductConfigurations,
    unlockHubSpotCreditsProductConfigurations
  } = configureHubSpotCreditsProductConfigurations({
    creditsSkuId: creditsSkuId !== null && creditsSkuId !== void 0 ? creditsSkuId : null,
    size,
    unlockHubSpotCreditsSkuIds
  });
  const purchaseMotions = usePurchaseMotionsForHubSpotCreditsTile({
    unlockHubSpotCreditsProductConfigurations,
    creditsLocation: location
  });
  if (!creditsProduct || !creditsSkuId) {
    return null;
  }
  const productIdentifier = `hubspot-credits-committed-${size}`;
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${productIdentifier}-merch-card`,
    "data-selenium-id": `${productIdentifier}-merch-card`,
    columnStart: columnStart,
    isUngatedForInbound25: isUngatedForInbound25,
    Title: /*#__PURE__*/_jsx(SectionTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `merchCards.hubSpotCredits.${size}.title`
      })
    }),
    Subheading: /*#__PURE__*/_jsx(SectionSubTitle, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `merchCards.hubSpotCredits.${size}.subtitle`
        })
      })
    }),
    Pricing: /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "400",
      children: /*#__PURE__*/_jsx(HubSpotCreditsTilePrice, {
        quantity: SIZE_TO_QUANTITY_MAP[size],
        seleniumId: productIdentifier,
        term: queryParamTerm,
        isHubspotCredits: true
      })
    }),
    CTAs: !!screen && /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "400",
      children: /*#__PURE__*/_jsx(HubSpotCreditsTileCTAs, {
        screen: screen,
        purchaseMotions: purchaseMotions,
        productConfigurations: purchaseProductConfigurations,
        location: location,
        trackingSource: `${size}-${HUBSPOT_CREDITS_CARD}`,
        productIdentifier: productIdentifier
      })
    }),
    Features: /*#__PURE__*/_jsx(CreditsFeatures, {
      size: size,
      isCollapsible: isCollapsible,
      loading: !isAppReady,
      subscreen: subscreen
    })
  });
};
export default HubSpotCreditsTileInbound25;